import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Image } from 'components/core/Image';
import { Button } from 'components/core/Button';

import { Paragraph } from 'components/core/Typography';

import MapIcon from 'assets/images/search/map-icon.svg';
import ListIcon from 'assets/images/search/list-icon.svg';
import FiltersIcon from 'assets/images/search/filters-icon.svg';
import FilledPhoneIcon from 'assets/images/search/filled-phone-icon.svg';

import classNames from 'classnames';

import { get } from 'lodash';

import './SearchCTCFooter.scss';

export function SearchCTCFooter({
	onOpenFilters,
	filtersCount = 0,
	mobileView,
	handleViewListMap,
	withinCallCenterHours,
	phone = null,
	className,
}) {
	const rawPhoneNumber = get(phone, 'nationalSparephoneUnformatted');
	const callHref = rawPhoneNumber ? `tel:${rawPhoneNumber}` : null;
	const shouldRenderCallButton = withinCallCenterHours && !!callHref;

	return (
		<div className={classNames('sticky-search-footer', className)}>
			<Button
				className="view-switcher-button"
				type="button"
				onClick={handleViewListMap}
				dark
				outline
			>
				{mobileView == 'list' ? (
					<Fragment className="button-content">
						<Image
							src={MapIcon}
							alt="Map tool bar icon"
							height={16}
							width={16}
						/>
						<Paragraph
							color="white"
							size="small"
							weight="medium"
							last
						>
							Map
						</Paragraph>
					</Fragment>
				) : (
					<Fragment className="button-content">
						<Image
							src={ListIcon}
							height={16}
							width={16}
						/>
						<Paragraph
							color="white"
							size="small"
							weight="medium"
							last
						>
							List
						</Paragraph>
					</Fragment>
				)}
			</Button>

			<Button
				className="filter-button"
				type="button"
				onClick={onOpenFilters}
				dark
				outline
			>
				<Image
					src={FiltersIcon}
					alt="Filters tool bar icon"
					height={16}
					width={16}
				/>
				<Paragraph
					color="white"
					size="small"
					weight="medium"
					last
				>
					Filter
				</Paragraph>
				{filtersCount > 0 && (
					<span
						className="filter-count"
						aria-label={`${filtersCount} filters selected`}
					>
						{filtersCount}
					</span>
				)}
			</Button>

			{shouldRenderCallButton && (
				<div className="click-to-show-call-button">
					<Button
						className="call-now"
						dark
						outline
						href={callHref}
					>
						<span className="phone-number">
							<Image
								src={FilledPhoneIcon}
								alt="Phone icon"
								height={16}
								width={16}
							/>
							Need Help?
						</span>
					</Button>
				</div>
			)}
		</div>
	);
}

SearchCTCFooter.propTypes = {
	onOpenFilters: PropTypes.func.isRequired,
	filtersCount: PropTypes.number,
	className: PropTypes.string,
	phone: PropTypes.shape({
		nationalSparephone: PropTypes.string.isRequired,
		nationalSparephoneUnformatted: PropTypes.string.isRequired,
	}),
	mobileView: PropTypes.bool.isRequired,
	handleViewListMap: PropTypes.func.isRequired,
	withinCallCenterHours: PropTypes.bool.isRequired,
};

export default SearchCTCFooter;
